module.exports = __webpack_public_path__ + "img/grandville_loop.db4b7e98.jpg";